@for (form of forms().controls; track form; let i = $index) {
  <glxy-form-row [formGroup]="form">
    <glxy-form-field class="col-xs-12 col-sm-5" [hideRequiredLabel]="true" bottomSpacing="small">
      <input
        type="text"
        matInput
        formControlName="name"
        placeholder="{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.HEADER_NAME_PLACEHOLDER' | translate }}"
      />
    </glxy-form-field>
    <glxy-form-field class="col-xs-12 col-sm-6" [hideRequiredLabel]="true" bottomSpacing="small">
      <input
        [style.-webkit-text-serity]="isAuthorizationHeader(form) ? 'disc' : 'none'"
        [style.text-security]="isAuthorizationHeader(form) ? 'disc' : 'none'"
        [attr.type]="'text'"
        matInput
        formControlName="value"
        placeholder="{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.HEADER_VALUE_PLACEHOLDER' | translate }}"
      />
    </glxy-form-field>
    @if (forms().enabled) {
      <button mat-icon-button class="col-xs-12 col-sm-1" (click)="handleRemove($index)">
        <mat-icon>close</mat-icon>
      </button>
    }
  </glxy-form-row>
}
<div class="header-buttons">
  @if (forms().enabled) {
    <button mat-button type="button" color="primary" class="add-button" (click)="handleAdd()">
      {{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.ADD_HEADER' | translate }}
    </button>
    <button mat-button [matMenuTriggerFor]="menu" color="primary" type="button">
      {{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.ADD_COMMON_HEADER' | translate }}
      <mat-icon class="dropdown-arrow" iconPositionEnd>arrow_drop_down</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      @for (commonHeader of commonHeaderOptions; track commonHeader) {
        <button mat-menu-item (click)="handleAdd(commonHeader.header)">
          {{ commonHeader.label }}
        </button>
      }
    </mat-menu>
  }
</div>
